import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const AuthLayout: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};
